<div>
  <h4>View vital:</h4>
  <p-select [options]="viewableVitals" [(ngModel)]="selectedVital" (onChange)="onViewChange()"></p-select>
</div>

<div echarts *ngIf="hasData" [options]="options" class="vitals-chart"></div>